import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64Z",
      style: {"fill":"none","stroke":"currentColor","stroke-miterlimit":"10","stroke-width":"32px"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M256 128v144h96",
      style: {"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"32px"}
    }, null, -1)
  ]))]))
}
export default { render: render }